import React from "react";
import { v4 as uuidv4 } from "uuid";
import { I } from "services/lang/LanguageService";
import "./UniversalDatasetTable.scss";
import { ColumnOptions } from "./UniversalDatasetTableTypes";

interface UniversalDatasetTableHeaderRowProps {
  columnsOptions: ColumnOptions[];
}
const UniversalDatasetTableHeaderRow = ({
  columnsOptions,
}: UniversalDatasetTableHeaderRowProps) => {
  return (
    <tr id="universal-table-head" className="text-left">
      {columnsOptions.map(column => {
        if (column.columnHeaderVisibility && column.columnVisibility) {
          return <th key={uuidv4()}>{I(column.title)}</th>;
        }
        if (!column.columnVisibility) {
          return null;
        }
        return <th key={uuidv4()} />;
      })}
    </tr>
  );
};

export default UniversalDatasetTableHeaderRow;
